<template src="./template.html"></template>
<script>
import Vue from 'vue'
import Promise from 'bluebird'
import moment from 'moment'
import _get from 'lodash/get'
import _find from 'lodash/find'
import { mapState } from 'vuex'

import bookingService from 'api/booking'
import userService from 'api/user'
import Login from 'components/Login'
import store from 'store'
import * as mutationTypes from 'store/mutationTypes'
import dateUtils from 'utils/dateUtils'
import analyticsLib from 'lib/analytics'
import eventBus from 'lib/eventBus'
import TRACKING_EVENTS from 'constants/trackingEvents'
import PAYMENT_TYPES from 'constants/paymentTypes'
import TABLELIST_TERMS from 'constants/tablelistTerms'
import BOOKING_PAYMENT_TYPES from 'constants/bookingPaymentTypes'
import INVENTORY_TYPES from 'constants/inventoryTypes'
import VENUE_TYPES from 'constants/venueTypes'
import bookingDiscountService from 'api/bookingDiscount'
import iframeLib from 'lib/iframe'
import storageLib from 'lib/storage'

function generateArrivalTimes(start, end) {
  const arrivalTimes = []

  for (let i = start; i <= end; i += 1800000) {
    arrivalTimes.push(i)
  }

  return arrivalTimes
}

const TERMS_INVALID_ERROR_MSG = 'terms invalid'
const FORM_INVALID_MSG = 'form is invalid'
const EMAIL_IS_REQUIRED_ERROR = 'email is required'
const CARD_IMCOMPLETE_ERROR_MSG = 'Your card number is incomplete.'
const PAYMENT_REQUEST_CANCELLED = 'Payment request cancelled'

function getArrivalTimeFromWonkyQueryParam() {
  const part1 = window.location.href.split('&amp%3B').find((p) => p.indexOf('arrivalTime') >= 0)

  if (!part1) return null

  const arrivalParts = part1.split('=')

  return arrivalParts && arrivalParts.length > 1 ? arrivalParts.pop() : null
}

export default {
  name: 'checkout',
  props: {
    hideVenueInfo: {
      type: Boolean,
      default: false,
    },
    enableGuestCheckout: {
      type: Boolean,
      default: false,
    },
    disableQuantity: {
      type: Boolean,
      default: false,
    },
    checkoutCompleteRouteName: {
      type: String,
    },
    showBackBtn: {
      type: Boolean,
      default: false,
    },
    backBtnRouteName: {
      type: String,
    },
  },
  data() {
    return {
      VENUE_TYPES,
      PAYMENT_TYPES,
      BOOKING_PAYMENT_TYPES,
      guestCheckout: false,
      cityId: this.$route.query.cityId,
      eventId: this.$route.query.eventId,
      loading: false,
      loadingItems: false,
      purchasing: false,
      bookingForm: {
        email: null,
        firstName: null,
        lastName: null,
        phone: null,
        birthday: null,
        arrivalTime: undefined,
        acceptedTerms: [],
        customerMarketingOptIn: false,
        customerMarketingOptInSignature: null,
        pickUpType: null,
        pickUpTimeInventoryId: null,
        medicalId: null,
        medicalState: null,
        medicalExpirationDate: null,
        medicalExpirationMonth: null,
        medicalExpirationYear: null,
      },
      currentPaymentProfile: null,
      terms: [],
      showTermsError: false,
      showPaymentProfileError: false,
      paymentType: null,
      arrivalTimes: [],
      nameOrEmailError: null,
      //discounts
      showDiscountForm: false,
      discountErrorMessage: null,
      discountApplied: false,
      discountForm: {
        promoCode: null,
      },
      showTermsAndConditions: false,
      tablelistTerms: TABLELIST_TERMS,
      termsAndConditions: null,
      pickUpTimeInventory: null,
    }
  },
  components: {
    Login,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      date: (state) => state.date.current,
      user: (state) => state.user.current,
      venue: (state) => state.venue.current,
      booking: (state) => state.checkout.booking,
      items: (state) => state.checkout.items,
      currentPaymentType: (state) => state.checkout.paymentType,
      //
      // eventId: state => state.config.eventId,
      attributionId: (state) => state.config.attributionId,
      affiliateId: (state) => state.config.affiliateId,
      trackingId: (state) => state.config.trackingId,
      client: (state) => state.config.client,
    }),
    purchaseComplete() {
      if (!this.booking) return false

      return this.booking.status === 'COMPLETE'
    },
    venueLogoStyles() {
      const logo = this.venue.logo || 'https://s3.amazonaws.com/tablelist-assets/www-2/nightpro-widgets/tablelist-widget-logo.png'

      return {
        'background-image': `url("${logo}")`,
      }
    },
    inventoryTerms() {
      if (!this.booking || !this.booking.items || !this.booking.items.length) return ''

      const terms = _get(this.booking.items[0], 'inventory.termsAndConditions') || ''

      return `<h2 class="main-h2">${this.venue.name}</h2><h2 class="sub-h2">Terms &amp; Conditions</h2>
      ${terms}`
    },
    hasNoItems() {
      return !this.booking || !this.booking.items || !this.booking.items.length
    },
    showInvalidFormatError() {
      return _find(this.errors.items, (item) => {
        return item.field === 'birthday' && item.rule === 'date_format'
      })
    },
  },
  methods: {
    showVenueTerms() {
      this.termsAndConditions = this.inventoryTerms

      this.showTermsAndConditions = true
    },
    showTerms() {
      this.termsAndConditions = this.tablelistTerms

      this.showTermsAndConditions = true
    },
    scrollTo(scrollTop = 0) {
      const modalEls = document.querySelectorAll('.modal-scroll')

      Vue.nextTick(() => {
        if (modalEls && modalEls.length) {
          modalEls[0].scroll({
            top: scrollTop,
            left: 0,
            behavior: 'smooth',
          })
        } else if (iframeLib.inIframe()) {
          this.$emit('scroll-top', scrollTop)
        } else {
          window.scroll({
            top: scrollTop,
            left: 0,
            behavior: 'smooth',
          })
        }
      })
    },
    onInventoryQuantityChanged() {
      return this.createBooking()
    },
    logoutGuest() {
      return this.$store.dispatch('removeCurrentUser')
    },
    logout() {
      this.$store.dispatch('logout')
    },
    onPaymentTypeChanged(paymentType) {
      this.$store.dispatch('setCheckoutPaymentType', paymentType)
    },
    createBooking(reloadItems = false) {
      this.nameOrEmailError = null

      if (!reloadItems) {
        this.loading = true
      } else {
        this.loadingItems = true

        if (!this.booking.items || !this.booking.items.length) {
          this.loadingItems = false

          this.scrollTo(0)

          return Promise.resolve()
        }
      }

      const data = {
        prospect: !this.loggedIn && this.user ? this.user.guid : undefined,
        status: 'OPEN',
        items: (reloadItems ? this.booking.items : this.items).map((item) => {
          return {
            inventoryId: reloadItems ? item.inventory.id : item.inventoryId,
            quantity: parseInt(item.quantity, 10),
          }
        }),
        eventId: this.eventId,
        attributionId: this.attributionId,
        affiliateId: this.affiliateId,
        trackingId: this.trackingId,
        client: this.client,
        user: this.user ? this.user.id : undefined,
        payment: this.paymentType,
        pickUpType: this.bookingForm.pickUpType,
        arrivalTime: this.bookingForm.arrivalTime,
      }

      if (this.user) {
        data.phone = this.user.phone
      }

      return bookingService
        .create(data)
        .then((booking) => {
          this.$store.dispatch('setCheckoutBooking', booking)

          this.paymentType = this.booking.payment

          if (this.booking.user) {
            this.bookingForm.firstName = this.booking.user.firstName
            this.bookingForm.lastName = this.booking.user.lastName
            this.bookingForm.email = this.booking.user.email
            this.bookingForm.phone = (this.booking.user.phone || '').toString()

            if (this.booking.user.birthday) {
              const birthday = moment(this.booking.user.birthday, 'x')
              this.bookingForm.birthday = birthday.format('MM/DD/YYYY')
            }
          }

          this.bookingForm.customerMarketingOptIn = this.booking.customerMarketingOptIn
          this.bookingForm.customerMarketingOptInSignature = this.booking.customerMarketingOptInSignature

          if (this.booking.inventoryType === INVENTORY_TYPES.PACKAGE) {
            const inventory = this.booking.items[0].inventory

            const start = moment.utc(inventory.start, 'x')
            let end = moment.utc(inventory.end, 'x')

            if (end.isBefore(start)) {
              end = start.clone().hour(6).minute(0).second(0)
            }

            const startUnix = inventory.arrivalStartTime || Number(start.format('x'))
            const endUnix = inventory.arrivalEndTime || Number(end.format('x'))

            this.arrivalTimes = generateArrivalTimes(startUnix, endUnix)

            const arrivalTimeFromWonkyQueryParam = getArrivalTimeFromWonkyQueryParam()

            if (this.$route.query.arrivalTime) {
              const date = moment(this.$route.query.arrivalTime, 'x')

              if (date.isValid()) {
                this.arrivalTimes = [date.toDate()]

                this.bookingForm.arrivalTime = date.toDate()
              }
            } else if (arrivalTimeFromWonkyQueryParam) {
              const date = moment(arrivalTimeFromWonkyQueryParam, 'x')

              if (date.isValid()) {
                this.arrivalTimes = [date.toDate()]

                this.bookingForm.arrivalTime = date.toDate()
              }
            }
          }

          if (!reloadItems) {
            this.loading = false
          } else {
            this.loadingItems = false
          }

          return this.trackOrderStarted()
        })
        .catch((error) => {
          if (!reloadItems) {
            this.loading = false
          } else {
            this.loadingItems = false
          }

          this.scrollTo(0)

          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })

          this.$store.dispatch('clearCheckoutCartItems')
        })
    },
    updateBookingItems() {
      return this.createBooking(true).then(() => {
        return null
      })
    },
    completeBooking() {
      if (this.purchasing) {
        return null //prevent double calls
      }

      this.nameOrEmailError = false
      this.purchasing = true

      return this.$validator
        .validateAll('bookingForm')
        .then((success) => {
          if (!success) {
            const nameError = this.$validator.errors.has('bookingForm.firstName') || this.$validator.errors.has('bookingForm.lastName')
            const emailError = this.$validator.errors.has('bookingForm.email')
            const phoneError = this.$validator.errors.has('bookingForm.phone')
            const arrivalTimeError = this.$validator.errors.has('bookingForm.arrivalTime')
            const signatureError = this.$validator.errors.has('bookingForm.customerMarketingOptInSignature')
            const pickUpError = this.$validator.errors.has('bookingForm.pickUpTimeInventoryId')
            const medicalError = this.$validator.errors.has('bookingForm.medicalId')

            if (nameError || emailError || phoneError || arrivalTimeError) {
              this.scrollTo(0)
            } else if (signatureError) {
              this.scrollTo(600)
            } else if (pickUpError) {
              this.scrollTo(300)
            } else if (medicalError) {
              this.scrollTo(800)
            }

            throw new Error(FORM_INVALID_MSG)
          }
        })
        .then(() => {
          return this._updateCurrentUser()
        })
        .then(() => {
          return this._completeBooking()
        })
        .catch(this._handleBookingCompleteErrors)
    },
    _updateCurrentUser() {
      const userUpdates = {
        firstName: this.user && this.bookingForm.firstName !== this.user.firstName ? this.bookingForm.firstName : this.bookingForm.firstName,
        lastName: this.user && this.bookingForm.lastName !== this.user.lastName ? this.bookingForm.lastName : this.bookingForm.lastName,
        email: this.user && this.bookingForm.email !== this.user.email ? this.bookingForm.email : this.bookingForm.email,
        phone: this.bookingForm.phone,
        marketingOptIn: this.bookingForm.customerMarketingOptIn,
        marketingOptInSignature: this.bookingForm.customerMarketingOptInSignature,
      }

      if (this.bookingForm.birthday) {
        userUpdates.birthday = dateUtils.toUTCTimestampWithoutTime(moment(this.bookingForm.birthday, 'MM/DD/YYYY'))
      }

      if (!userUpdates.firstName || !userUpdates.lastName || !userUpdates.email) {
        this.nameOrEmailError = true

        throw new Error(EMAIL_IS_REQUIRED_ERROR)
      }

      return userService.updateMe(userUpdates)
    },
    _completeBooking() {
      if (this.booking.payment === 'NONE') {
        return this._completeBookingBookingWithoutPayment()
      }
      const data = {
        cancelUrl: iframeLib.topLevelUrl(),
      }
      return bookingService.checkoutById(this.booking.id, data).then((session) => {
        if (iframeLib.inIframe()) {
          this.$emit('checkoutSessionCreated', session)
        } else {
          window.location = session.url
        }
      })
    },
    _completeBookingBookingWithoutPayment() {
      return bookingService.completeById(this.booking.id, {}).then((booking) => {
        this.purchasing = false
        this.$store.dispatch('setCheckoutBooking', booking)
        this.$store.dispatch('clearCheckoutCartItems')

        if (this.checkoutCompleteRouteName) {
          this.$router.push({
            name: this.checkoutCompleteRouteName,
            query: {
              bookingId: booking.id,
            },
          })
        }

        this.$emit('bookingCompleted', booking)

        this.scrollTo(0)

        this.trackCompletedOrder()

        return null
      })
    },
    _handleBookingCompleteErrors(error) {
      if (!error) return

      if (error.message === PAYMENT_REQUEST_CANCELLED) {
        this.purchasing = false

        return
      }

      if (error.message === EMAIL_IS_REQUIRED_ERROR) {
        this.purchasing = false

        return
      }

      this.purchasing = false

      const errorMessage = error && (error.message === TERMS_INVALID_ERROR_MSG || error.message === FORM_INVALID_MSG || error.message === CARD_IMCOMPLETE_ERROR_MSG) ? null : error.message

      if (errorMessage) {
        this.scrollTo(0)

        this.$store.dispatch('addTopBarNotification', {
          text: errorMessage,
        })
      }
    },
    updateBookingDate() {
      return bookingService
        .updateById(this.booking.id, {
          date: dateUtils.toUTCDateWithoutTime(this.date),
        })
        .then((booking) => {
          this.$store.dispatch('setCheckoutBooking', booking)
        })
        .catch((error) => {
          this.loading = false

          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })
        })
    },
    updateBookingArrivalTime() {
      return bookingService
        .updateById(this.booking.id, {
          arrivalTime: this.bookingForm.arrivalTime,
        })
        .then((booking) => {
          this.$store.dispatch('setCheckoutBooking', booking)
        })
        .catch((error) => {
          this.loading = false

          this.$store.dispatch('addTopBarNotification', {
            text: error.message,
          })
        })
    },
    onMutation(mutation) {
      if (mutation.type === mutationTypes.SET_CURRENT_USER) {
        this.showPaymentProfileError = false

        if (this.user && this.user.guid) {
          this.guestCheckout = true
        } else {
          this.guestCheckout = false
        }

        if (this.loggedIn) {
          this.createBooking().then(() => {
            return null
          })
        }
      } else if (mutation.type === mutationTypes.SET_CURRENT_DATE) {
        this.updateBookingDate()
      }
    },
    //tracking
    trackCompletedOrder() {
      const orderTrackingData = {
        bookingId: this.booking.id,
        admissionGroupId: this.booking.admissionGroup,
        venueId: this.venue.id,
        venueName: this.venue.name,
        cityId: this.booking.city,
        client: this.booking.client,
        currency: this.venue.currencyCode,
        price: this.booking.price,
        tax: this.booking.tax,
        tip: this.booking.tip,
        total: this.booking.totalWithoutCredit,
        inventoryType: this.booking.inventoryType,
        inventoryMembershipLevel: this.booking.inventoryMembershipLevel,
        discount: this.booking.credit,
        revenue: this.booking.price,
        items: this.booking.items.map((item) => {
          return {
            id: item.inventory.id,
            name: item.name,
            inventoryType: item.type,
            quantity: item.quantity,
            price: item.price,
          }
        }),
      }

      this.booking.items.forEach((item) => {
        analyticsLib.trackEvent(TRACKING_EVENTS.PurchasedItem, {
          bookingId: this.booking.id,
          admissionGroupId: this.booking.admissionGroup,
          venueId: this.venue.id,
          venueName: this.venue.name,
          cityId: this.booking.city,
          client: this.booking.client,
          currency: this.venue.currencyCode,
          inventoryId: item.inventory.id,
          inventoryName: item.inventory.name,
          price: item.price,
          quantity: item.quantity,
        })
      })

      analyticsLib.trackEvent(TRACKING_EVENTS.BookingCompleted, orderTrackingData)

      //start a new session
      storageLib.setSessionToken()
    },
    trackOrderStarted() {
      this.booking.items.forEach((item) => {
        analyticsLib.trackEvent(TRACKING_EVENTS.StartedCheckoutItem, {
          bookingId: this.booking.id,
          venueId: this.venue.id,
          venueName: this.venue.name,
          cityId: this.booking.city,
          client: this.booking.client,
          currency: this.venue.currencyCode,
          inventoryId: item.inventory.id,
          inventoryName: item.inventory.name,
          inventoryType: item.inventory.type,
          inventoryCannabisType: item.inventory.cannabisType,
          price: item.price,
          quantity: item.quantity,
          bookingTotal: this.booking.total,
        })
      })

      return analyticsLib.trackEvent(TRACKING_EVENTS.StartedCheckout, {
        bookingId: this.booking.id,
        venueId: this.venue.id,
        venueName: this.venue.name,
        cityId: this.booking.city,
        client: this.booking.client,
        currency: this.venue.currencyCode,
        price: this.booking.price,
        tax: this.booking.tax,
        tip: this.booking.tip,
        total: this.booking.totalWithoutCredit,
        inventoryType: this.booking.inventoryType,
        inventoryMembershipLevel: this.booking.inventoryMembershipLevel,
        discount: this.booking.credit,
        revenue: this.booking.price,
        items: this.booking.items.map((item) => {
          return {
            id: item.inventory.id,
            name: item.name,
            inventoryType: item.type,
            quantity: item.quantity,
            price: item.price,
          }
        }),
      })
    },
    //discounts
    redeemDiscount() {
      this.discountErrorMessage = null
      this.discountApplied = false

      return this.$validator.validateAll('discountForm').then((success) => {
        if (success) {
          return bookingDiscountService
            .createByBookingId(this.booking.id, {
              id: this.booking.id,
              promoCode: this.discountForm.promoCode,
            })
            .then((updatedBooking) => {
              this.discountApplied = true

              this.$store.dispatch('setCheckoutBooking', updatedBooking)
            })
            .catch((err) => {
              this.discountErrorMessage = err.message
            })
        }

        return null
      })
    },
  },
  mounted() {
    if (!this.venue) throw new Error('venue')
    if (!this.items || !this.items.length) throw new Error('cart has no items')

    this.loading = true

    const promises = [this.$store.dispatch('getCurrentUser')]

    if (this.showPickUpOptions) {
      this.bookingForm.pickUpType = this.pickUpTypes[0].type
    }

    Promise.all(promises)
      .then(() => {
        this.storeUnsubscribe = store.subscribe(this.onMutation)

        return this.createBooking()
      })
      .then(() => {
        this.loading = false

        if (this.$store.state.config.eventId) {
          this.eventId = this.$store.state.config.eventId
        }
      })
      .catch((error) => {
        this.loading = false

        this.$store.dispatch('addTopBarNotification', {
          text: error.message,
        })
      })
  },
  updated() {
    eventBus.$emit('updated')
  },
  destroyed() {
    if (this.storeUnsubscribe) this.storeUnsubscribe()

    this.$store.dispatch('setCheckoutBooking', null)

    if (this.checkoutCompleteRouteName) {
      this.$store.dispatch('clearCheckoutCartItems')
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Checkout/index.vue